import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';

import * as fromReducer from './devices-active-syncs.reducer';
import { DeviceActiveSyncsState } from './devices-active-syncs.state';

export const selectActiveDeviceSyncsState = createFeatureSelector<DeviceActiveSyncsState>('deviceActiveSyncsState');

export const selectActiveDeviceSyncs = createSelector(
  selectActiveDeviceSyncsState,
  fromReducer.selectCurrentActiveDeviceSyncs
);

export const selectCurrentActiveDeviceSyncs: Selector<object, number[]> = createSelector(
  selectActiveDeviceSyncs,
  (activeSyncs) => activeSyncs
);
